import Vue from 'vue'

// Vue must ignore custom components that aren't Vue Components
Vue.config.ignoredElements = [
  'hot-breadcrumb',
  'hot-breadcrumb-item',
  'hot-card-footer',
]
